/**
 * MonetizationTypeAccessoriesCtrl controller
 */

// controller mixins
import { remove } from '../../app/helpers/entity'
import { ACCESSORY_TYPES_FOR_FILTERS } from '../../app/core/constants'

MonetizationTypeAccessoriesCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * MonetizationTypeAccessoriesCtrl controller
 *
 * @class MonetizationTypeAccessoriesCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:MonetizationTypeAccessoriesCtrl
 */
/* @ngInject */
export default function MonetizationTypeAccessoriesCtrl ($scope, SubscriptionAccessory, pckg) {
  const vm = this
  vm.accessoryTypes = ACCESSORY_TYPES_FOR_FILTERS
  /**
   * Accessories list
   *
   * @memberof mwApp/packages.controller:MonetizationTypeAccessoriesCtrl
   * @name vm.accessories
   * @type {models.SubscriptionAccessory[]}
   */
  vm.accessories = []

  SubscriptionAccessory.loadAll({ networkId: pckg.id })
    .to(vm.accessories = [])

  /**
   * Package/Network/Organization
   *
   * @memberof mwApp/packages.controller:MonetizationTypeAccessoriesCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Delete Accessory
   *
   * @memberof mwApp/packages.controller:MonetizationTypeAccessoriesCtrl
   * @param  {models.SubscriptionAccessory} entity
   */
  vm.delete = function (entity) {
    entity._delete()
      .then(remove(vm.accessories)(entity))
  }
}
